// react-app/src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut
} from "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBwNMP4rC_mdt4B9wa4FrIrPDWEHUjrZzk",
    authDomain: "mynursingplatform.firebaseapp.com",
    projectId: "mynursingplatform",
    storageBucket: "mynursingplatform.firebasestorage.app",
    messagingSenderId: "1090154065052",
    appId: "1:1090154065052:web:444b4a3f51822e6bb01159",
    measurementId: "G-MJMM8ZPPHB"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

// Auth and provider setup
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup, signOut, db };
